import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../Container';

export const ParagraphContent = styled.section`
  width: 100%;
  margin: 0 auto;
`;

export const Content = styled(Container)`
  background-color: transparent;
  color: ${themeGet('colors.body-copy')};
  margin: 0 auto;
  padding: 3.75rem 2rem;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 2.5rem 1rem;
  }

  &.no-margin {
    padding: 0 2rem;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      padding: 0 1rem;
    }
  }

  &.no-margin-top {
    padding: 0 2rem 3.75rem;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      padding: 0 1rem 2rem;
    }
  }

  &.no-margin-bottom {
    padding: 3.75rem 2rem 0;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      padding: 2.5rem 1rem 0;
    }
  }

  ${({ styledContent }) =>
    styledContent &&
    css`
      width: 100%;
      max-width: 60rem;

      @media (max-width: ${themeGet('breakpoints.lg')}) {
        max-width: 100%;
      }
    `}
`;

export const Bubble = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2.5rem;
  border-radius: 20px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
  margin: 0 auto 1rem;

  background-color: ${({ themes }) =>
    themes === 'dark' ? 'rgba(39, 39, 45, 0.7)' : 'rgba(249, 249, 249, 0.8)'};
`;
